import { createSlice } from '@reduxjs/toolkit';

const SESSION_DURATION = 20 * 60 * 1000;

const loadAuthFromStorage = () => {
  try {
    const authData = localStorage.getItem('yk_auth');
    if (authData) {
      const parsed = JSON.parse(authData);
      if (parsed.expiresAt && new Date(parsed.expiresAt) > new Date()) {
        return parsed;
      }
      localStorage.removeItem('yk_auth');
    }
  } catch (error) {
    console.error('Error loading auth from storage:', error);
  }
  return {
    isAuthenticated: false,
    user: null,
    entity: 'RMS',
    loginTime: null,
    expiresAt: null,
  };
};

const initialState = loadAuthFromStorage();

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action) => {
      const now = new Date();
      const expiresAt = new Date(now.getTime() + SESSION_DURATION);
      
      console.log('authSlice - login action payload:', action.payload);
      
      // Clear old auth data first
      localStorage.removeItem('yk_auth');
      
      state.isAuthenticated = true;
      // Store the entire payload as user (contains email, entity, userData)
      state.user = action.payload;
      state.entity = action.payload.entity || 'RMS';
      state.loginTime = now.toISOString();
      state.expiresAt = expiresAt.toISOString();

      console.log('authSlice - state after login:', { 
        isAuthenticated: state.isAuthenticated, 
        user: state.user,
        entity: state.entity 
      });
      
      // Save new auth state
      const authData = {
        isAuthenticated: state.isAuthenticated,
        user: state.user,
        entity: state.entity,
        loginTime: state.loginTime,
        expiresAt: state.expiresAt
      };
      console.log('authSlice - saving to localStorage:', authData);
      localStorage.setItem('yk_auth', JSON.stringify(authData));
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.loginTime = null;
      state.expiresAt = null;
      localStorage.removeItem('yk_auth');
    },
    updateUser: (state, action) => {
      state.user = { ...state.user, ...action.payload };
      localStorage.setItem('yk_auth', JSON.stringify(state));
    },
  },
});

export const { login, logout, updateUser } = authSlice.actions;
export default authSlice.reducer;
